module.exports = __webpack_public_path__ + "img/06.6c79efa5.png";